export default {
  init(vue) {
    return {
      /**
       * 
       * @param {startTime,endTime,goodsCode} params 
       * @returns 
       */
      promotep5m(params) {
        return vue.$http({
          method: 'GET',
          url: ` /oanalyse/pages/analyse/promote/p0goods`,
          params: params
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/analyse.service.js